// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TruncatedText__container-c90f56 {
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
}

.TruncatedText__left-part-cac769 {
  flex: 0 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.TruncatedText__right-part-bee0d7 {
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/TruncatedText/TruncatedText.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n.left-part {\n  flex: 0 1 auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.right-part {\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TruncatedText__container-c90f56`,
	"left-part": `TruncatedText__left-part-cac769`,
	"leftPart": `TruncatedText__left-part-cac769`,
	"right-part": `TruncatedText__right-part-bee0d7`,
	"rightPart": `TruncatedText__right-part-bee0d7`
};
module.exports = ___CSS_LOADER_EXPORT___;
